export default __webpack_public_path__ + "static/media/dislike-g.f8dfe8a9.svg";